import { TOGGLE_ASK_GET_LOCATION } from "./displayAskGetLocationReducer"

export const toggleAskGetLocation = (value) => ({
    type: TOGGLE_ASK_GET_LOCATION,
    payload: value
})